/**
 * Norce stores a boolean parametric as the string "True"/"False", so the PDP
 * spec tab read "Vattentät · True". `t` is a parameter to keep this pure.
 */
export const formatParametricValue = (
	value: string | null | undefined,
	t: (key: string) => string
): string => {
	if (!value) return "";

	const normalized = value.trim().toLowerCase();

	if (normalized === "true") return t("Yes");
	if (normalized === "false") return t("No");

	return value;
};
